import { z } from "zod";

import {
	Beds24RoomTypeMappingItemInputSchema,
	SiteControllerSettingBeds24InputSchema,
} from "@/lib/zod/__generated__/validation-schema";

export const siteControllerSettingBeds24InputZodSchema = SiteControllerSettingBeds24InputSchema.extend({
	beds24AuthenticationApiKey: z.string().min(1, { message: "APIキーは必須入力です" }).max(200),
	beds24AuthenticationPropKey: z.string().min(1, { message: "propキーは必須入力です" }).max(200),
	beds24RoomTypeMapping: z.array(
		z.lazy(() =>
			Beds24RoomTypeMappingItemInputSchema.extend({
				name: z.string(),
			}),
		),
	),
}).omit({
	// 使用施設が存在しないため、削除
	beds24AuthenticationPropKeys: true,
	// 使用施設が存在しないため、削除
	beds24UseMultiplePropKey: true,
});

export type SiteControllerSettingBeds24InputZodSchemaType = z.infer<typeof siteControllerSettingBeds24InputZodSchema>;
